import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import WorkerDropdown from './WorkerDropdown';
import cx from 'classnames';
import MultiSelectCheckbox from 'common/components/MultiSelectCheckbox';

class SiteFields extends Component {
  constructor(props) {
    super(props);

    this._onCommentChange = this._onCommentChange.bind(this);
    this._onWorkerChange = this._onWorkerChange.bind(this);
    this._onFinancialConditionChange = this._onFinancialConditionChange.bind(
      this
    );
    this._onPriceChange = this._onPriceChange.bind(this);
    this._onInterventionPlanChange = this._onInterventionPlanChange.bind(this);
    this._onIndustrialReferenceChange = this._onIndustrialReferenceChange.bind(
      this
    );
    this._onCustomerDirectiveChange = this._onCustomerDirectiveChange.bind(
      this
    );
    this._onSecurityEpisChange = this._onSecurityEpisChange.bind(this);
    this._onInventoryToPlanChange = this._onInventoryToPlanChange.bind(this);
    this._onPlanifConstraintChange = this._onPlanifConstraintChange.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  _onCommentChange(evt) {
    if (evt && evt.target) {
      this._onSiteChange({
        info_comment: evt.target.value || '',
      });
    }
  }

  _onWorkerChange(value) {
    this._onSiteChange({
      ref_tech_id: value,
    });
  }

  _onFinancialConditionChange(evt) {
    if (evt && evt.target) {
      this._onSiteChange({
        financial_condition: evt.target.value || '',
      });
    }
  }

  _onPriceChange(evt) {
    if (evt && evt.target) {
      this._onSiteChange({
        price: evt.target.value || '',
      });
    }
  }

  _onSiteChange(values) {
    const { site } = this.props;

    this.props.onChange(site, values);
  }

  _onInterventionPlanChange(evt) {
    if (evt && evt.target) {
      this._onSiteChange({
        intervention_plan: evt.target.value || '',
      });
    }
  }

  _onIndustrialReferenceChange(evt) {
    if (evt && evt.target) {
      this._onSiteChange({
        industrial_reference: evt.target.value || '',
      });
    }
  }

  _onCustomerDirectiveChange(evt) {
    if (evt && evt.target) {
      this._onSiteChange({
        customer_directive: evt.target.value || '',
      });
    }
  }

  _onSecurityEpisChange(epis) {
    this._onSiteChange({
      security_epis: epis || [],
    });
  }

  _onInventoryToPlanChange(inventory) {
    this._onSiteChange({
      inventory_to_plan: inventory || [],
    });
  }

  _onPlanifConstraintChange(evt) {
    if (evt && evt.target) {
      this._onSiteChange({
        planif_constraints: evt.target.value || '',
      });
    }
  }

  render() {
    const { site, workers, errors } = this.props;

    const fieldClassName = (name, existing = '') =>
      cx('field', existing, {
        error: errors.indexOf(name) > -1,
      });

    return (
      <div>
        <div className="fields">
          <div className={fieldClassName('info_comment', 'ten wide')}>
            <label>Commentaire général</label>
            <input
              type="text"
              value={site.info_comment || ''}
              onChange={this._onCommentChange}
            />
          </div>
          <WorkerDropdown
            site={site}
            hasError={errors.indexOf('ref_tech_id') > -1}
            workers={workers}
            onChange={this._onWorkerChange}
          />
        </div>
        <div className="two fields">
          <div className={fieldClassName('financial_condition')}>
            <label>Conditions Financières</label>
            <input
              type="text"
              value={site.financial_condition || ''}
              onChange={this._onFinancialConditionChange}
            />
          </div>
          <div className={fieldClassName('price')}>
            <label>Prix</label>
            <input
              type="text"
              value={site.price || ''}
              onChange={this._onPriceChange}
            />
          </div>
        </div>
        <MultiSelectCheckbox
          label="Matériel à prévoir"
          fields={this.props.inventoryToPlan}
          selected={site.inventory_to_plan}
          onChange={this._onInventoryToPlanChange}
        />
        <MultiSelectCheckbox
          label="EPI adaptés"
          fields={this.props.securityEpis}
          selected={site.security_epis}
          onChange={this._onSecurityEpisChange}
        />
        <div className={fieldClassName('planif_constraints')}>
          <label>Contrainte de planification</label>
          <input
            type="text"
            value={site.planif_constraints || ''}
            onChange={this._onPlanifConstraintChange}
          />
        </div>
        {!this.props.isNewCase && (
          <div>
            <div className="two fields">
              <div className={fieldClassName('intervention_plan')}>
                <label>Plan d'intervention</label>
                <input
                  type="text"
                  value={site.intervention_plan || ''}
                  onChange={this._onInterventionPlanChange}
                />
              </div>
              <div className={fieldClassName('industrial_reference')}>
                <label>Réference industrielle</label>
                <input
                  type="text"
                  value={site.industrial_reference || ''}
                  onChange={this._onIndustrialReferenceChange}
                />
              </div>
            </div>
            <div className="field">
              <div className={fieldClassName('customer_directive')}>
                <label>Consigne de sécurité client</label>
                <textarea
                  type="text"
                  defaultValue={site.customer_directive || ''}
                  rows="2"
                  maxLength="1024"
                  onChange={this._onCustomerDirectiveChange}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

SiteFields.propTypes = {
  site: PropTypes.object.isRequired,
  workers: PropTypes.array.isRequired,
  errors: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  isNewCase: PropTypes.bool,
};

export default SiteFields;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/components/SiteFields.js